import * as React from "react";
import * as Immutable from "immutable";
import TeamsAssignment from "../teams-assignment/TeamsAssignment";
import TeamsDomain from "../../domainActions/TeamsDomain";
const RolesTeamsAssignment = ({ role, readOnly }) => {
  const _getUnassignedTeams = (teams) => teams.filter((t) => !t.roles.includes(role.id)).toList();
  const _loadAssignedTeams = (pagination) => TeamsDomain.loadTeamsForRole(role.id, pagination);
  const _unassignTeam = (teamId) => TeamsDomain.removeRole(role.id, teamId);
  const _assignTeams = (teamIds) => TeamsDomain.addRoleToTeams(role.id, teamIds);
  const _buildTeamWithEntity = (team) => team.toBuilder().roles(Immutable.Set([role.id])).build();
  return /* @__PURE__ */ React.createElement(
    TeamsAssignment,
    {
      getUnassignedTeams: _getUnassignedTeams,
      readOnly,
      loadAssignedTeams: _loadAssignedTeams,
      unassignTeam: _unassignTeam,
      buildTeamWithEntity: _buildTeamWithEntity,
      assignTeams: _assignTeams
    }
  );
};
export default RolesTeamsAssignment;
